import { GroupChatListScreenNavigationProps } from "./types"
import React from "react"
import GroupChatList from "./group-chat-list-screen"
import { PageRoot } from "~screens/page-root"


const GroupChatListScreen: React.FC<GroupChatListScreenNavigationProps> = () => {
  return (
    <PageRoot>
      <GroupChatList />
    </PageRoot>
  )
}

export default GroupChatListScreen
